import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react'
import { RichText, Link, Image } from '@sitecore-jss/sitecore-jss-react';  
import Slider from "react-slick";

import '../../assets/css/0020_objects/0750_obj_a_la_une_formation.css'
import '../../assets/css/0020_objects/0710_obj_carousel_formation.css';

class ObjALaUneHomeFormation extends Component {
	onSwipe() {
        if (this.slider) {
          	this.slider.innerSlider.clickable = true;
        }
	}

	render() {
        const { scDatasPushs, scDatasBrandName } = this.props;

		const sliderRef = slider => {this.slider = slider}
		const settings = {
            className: "obj_carousel_formation obj_carrousel_slider",
            centerMode: false,
			infinite: false,
			slidesToShow: 1,
			swipeToSlide: true,
			onSwipe: this.onSwipe.bind(this),
            dots: false,
            dotsClass:  "slider-nav",
            appendDots: dots => (
                <div className="slider-nav" >
                    <ul> {dots} </ul>
                </div>
            ),
            arrows: true,
            speed: 750,
			responsive: [
                {
                    breakpoint: 768,
                    settings: {
						dots: true,
						centerMode: false,
						arrows: false
                    }
                }
            ]
        }

		return (<> {scDatasPushs && <>
			<div className="obj_a_la_une_formation">
				<div className="ctn_title">
					<h3 className="t_title"><strong>&Agrave; la une</strong></h3>
					<p className="t_desc">chez {scDatasBrandName}</p>
				</div>

				<div className="ctn_carrousel">
					<Slider {...settings} ref={sliderRef}>
						{ scDatasPushs.map((ALaUneItemsItem, index) => (
							<div className="item" key={index}>
								
								<div className="item_a_la_une_formation">
									<div className="ctn_media">
										<div className="obj_image">
											<picture className="ctn_image fade-in">
                                                <Image field={ALaUneItemsItem.visuel.jss}></Image>
											</picture>
										</div>
									</div>
									<div className="ctn_text">
										<p className="t_ribbon"><span>{ALaUneItemsItem.ribbon.value}</span></p>
                                        <RichText field={ALaUneItemsItem.title.jss} tag="h3" className="t_title"/>
                                        <RichText field={ALaUneItemsItem.desc.jss} tag="p" className="t_desc"/>
										<div className="ctn_cta">
											<Link className="obj_cta" field={ALaUneItemsItem.link.jss}>{ALaUneItemsItem.cta.value}</Link>
										</div>
									</div>
									{/* {ALaUneItemsItem.label} */}
								</div>

							</div>
						))}
					</Slider>
				</div>
			</div>
        </>}</>)
	}

}

export default withTranslation()(withSitecoreContext()(ObjALaUneHomeFormation));